import { err, ok } from '@nanovnaweb/shared';
import { ParseError } from '../warnings.js';
import { readTouchstoneString } from './reader.js';
import { writeTouchstoneString } from './writer.js';
export const touchstoneCodec = {
    kind: 'touchstone',
    extensions: ['.s1p', '.s2p'],
    mimeType: 'text/plain',
    async *read(blob) {
        const content = await blob.text();
        const result = readTouchstoneString(content);
        if (result.kind === 'err')
            throw result.error;
        yield result.value;
    },
    write(items) {
        const encoder = new TextEncoder();
        return new ReadableStream({
            async start(controller) {
                for await (const trace of items) {
                    controller.enqueue(encoder.encode(writeTouchstoneString(trace)));
                }
                controller.close();
            },
        });
    },
};
export async function readTouchstone(blob, opts) {
    try {
        for await (const result of touchstoneCodec.read(blob)) {
            if (opts?.suggestedName) {
                return ok({
                    trace: { ...result.trace, name: opts.suggestedName },
                    warnings: result.warnings,
                });
            }
            return ok(result);
        }
        return err(new ParseError('empty-file', 'no traces produced'));
    }
    catch (e) {
        if (e instanceof ParseError)
            return err(e);
        throw e;
    }
}
//# sourceMappingURL=index.js.map